



import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Api } from "../Api/Api";


const PendingCustomerList = (props) => {
  // ✅ SAFE current user read
  const currentUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("currentUser"));
    } catch {
      return null;
    }
  })();

  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [type, setType] = useState("all");
const [types, setTypes] = useState([]);


useEffect(() => {
  fetch(`${Api}customers/types/list.php`)
    .then((r) => r.json())
    .then((d) => setTypes(d.types || []))
    .catch(() => setTypes([]));
}, []);


  // HARD SAFETY
  const customers = Array.isArray(props?.customers) ? props.customers : [];

  const thClass =
    "px-4 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider border-b border-gray-200 bg-gray-50";
  const tdClass = "px-4 py-4 text-sm text-gray-700 border-b border-gray-100";

  const btnView =
    "px-3 py-1.5 rounded-md text-xs font-bold bg-white text-indigo-600 border border-indigo-100 hover:bg-indigo-600 hover:text-white";

  const formatDDMMYYYY = (dateStr) => {
    if (!dateStr) return "-";

    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  };

  // 🔍 SEARCH FILTER
// const filteredCustomers = useMemo(() => {
//   const q = search.toLowerCase();

//   return customers.filter((c) => {
//     const matchesSearch =
//       !search ||
//       c.name?.toLowerCase().includes(q) ||
//       c.customer_code?.toLowerCase().includes(q);

//     const matchesType = type === "all" || c.type === type;

//     return matchesSearch && matchesType;
//   });
// }, [search, type, customers]);


const filteredCustomers = useMemo(() => {
  const q = search.toLowerCase();

  return customers.filter((c) => {
    // ❌ Hide closed customers
    const notClosed =
      c.status?.toLowerCase() !== "close" &&
      c.status?.toLowerCase() !== "closed";

    const matchesSearch =
      !search ||
      c.name?.toLowerCase().includes(q) ||
      c.customer_code?.toLowerCase().includes(q);

    const matchesType = type === "all" || c.type === type;

    return notClosed && matchesSearch && matchesType;
  });
}, [search, type, customers]);



  return (
    <div className="space-y-4">
      {/* 🔍 Search Bar */}
     <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-4 pt-4">
  {/* 🔍 Search */}
  <input
    type="text"
    placeholder="Search by Customer Name or Code..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="w-full sm:max-w-md px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none"
  />

  {/* 🔽 Type Filter */}
  <select
    value={type}
    onChange={(e) => setType(e.target.value)}
    className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-bold bg-white"
  >
    <option value="all">All Types</option>
    {types.map((t) => (
      <option key={t.id} value={t.type_name}>
        {t.type_name}
      </option>
    ))}
  </select>

  <span className="text-sm text-gray-500 font-medium">
    {filteredCustomers.length} results
  </span>
</div>


      {/* 📋 Table */}
      {/* <div className="overflow-x-auto"> */}
      <div className="overflow-x-auto overflow-y-auto max-h-[70vh] border rounded-lg shadow">

        {/* <table className="w-full border-collapse min-w-max"> */}
        <table className="border-collapse text-sm min-w-[1100px] w-full">

          <thead>
            <tr>
              <th className={thClass}>S.No</th>
              <th className={thClass}>Code</th>
              <th className={thClass}>Customer</th>
              <th className={thClass}>Loan Date</th>
              <th className={thClass}>Mobile</th>
              <th className={thClass}>Weekly Int.</th>
              <th className={thClass}>Pending Amount</th>
              <th className={thClass}>Status</th>
              <th className={thClass}>View</th>
            </tr>
          </thead>

          <tbody className="bg-white">
            {filteredCustomers.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center py-10 text-gray-400 italic">
                  No matching pending customers
                </td>
              </tr>
            ) : (
              filteredCustomers.map((c, index) => (
                <tr key={c.id || index} className="hover:bg-gray-50">
                  <td className={`${tdClass} text-gray-400`}>
                    {String(index + 1).padStart(2, "0")}
                  </td>

                  <td className={`${tdClass} font-semibold text-indigo-700`}>
                    {c.customer_code}
                  </td>

                  <td className={`${tdClass} font-bold`}>{c.name}</td>

                  <td className={tdClass}>
                    {formatDDMMYYYY(c.given_date)}
                  </td>

                  <td className={tdClass}>{c.mobile1}</td>

                  <td className={`${tdClass} font-bold text-blue-700`}>
                    ₹{Number(c.weekly_interest_amount).toLocaleString()}
                  </td>

                  <td className={`${tdClass} font-bold text-red-600`}>
                    ₹{Number(c.pending).toLocaleString()}
                  </td>

                  <td className={tdClass}>
                    <span className="px-2 py-1 rounded-full text-xs font-bold bg-orange-100 text-orange-800">
                      Pending
                    </span>
                  </td>

                  <td className={tdClass}>
                    <button
                      onClick={() =>
                        navigate(
                          currentUser?.role === "staff"
                            ? `/staff/customers/${c.id}`
                            : `/admin/customers/${c.id}`
                        )
                      }
                      className={btnView}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingCustomerList;

